import {
  Box,
  Card,
  DialogContent,
  SxProps,
  styled,
  Theme,
  Typography,
} from '@mui/material';
import { CommonProps } from '@mui/material/OverridableComponent';

type StyleProps = CommonProps['style'] | SxProps<any>;

const textFieldStyles: CommonProps['style'] = {
  width: '100%',
  alignSelf: 'center',
  marginBottom: 10,
  marginTop: 10,
};

export const PageHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.headerText,
}));

export const DialogHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.headerTextModal,
}));

export const SubHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.greyText,
  fontWeight: 400,
  color: theme.palette.black[50],
}));

export const SectionHeader = styled(Typography)(({ theme }) => ({
  ...theme.typography.headerTextSection,
  paddingBottom: theme.spacing(1),
}));

const closeButtonStyles = (theme: Theme): StyleProps => ({
  padding: '10px',
  minWidth: '44px',
  width: '44px',
  height: '44px',
  borderRadius: '50%',
  color: theme.palette.primary.dark,
  '&:hover': {
    opacity: 0.8,
    backgroundColor: theme.palette.primary.light,
    borderColor: theme.palette.primary.light,
    color: theme.palette.primary.dark,
  },
});

export const StyledSection = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  // border: `1px solid ${theme.palette.primary.light}`,
  // boxShadow: `0px 0px 5px ${theme.palette.primary.light}`,
  padding: theme.spacing(2),
  // borderRadius: theme.general.borderRadiusSm,
}));

export const StyledWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'start',
  flexDirection: 'column',
  gap: '1rem',
}));

export const StyledDialogContent = styled(DialogContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  flex: 1,
  overflow: 'auto',
}));

const dialogMediumBoxStyles: StyleProps = {
  width: '70vw',
  minHeight: '70vh',
  height: '70vh',
  maxHeight: '70vh',
  maxWidth: '700px',
  padding: '1.5rem',
  gap: '1rem',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  flex: 1,
  overflow: 'auto',
};

const dialogLargeBoxStyles: StyleProps = {
  width: '80vw',
  minHeight: '90vh',
  height: '90vh',
  maxHeight: '90vh',
  maxWidth: '1200px',
  padding: '1.5rem',
  gap: '1rem',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  flex: 1,
  overflow: 'hidden',
};

const globalStyles = {
  textField: {
    ...textFieldStyles,
  },

  closeButton: closeButtonStyles,

  dialogMediumBox: {
    ...dialogMediumBoxStyles,
  },

  dialogLargeBox: {
    ...dialogLargeBoxStyles,
  },
};

export default globalStyles;
